import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {VehicleStatusHeading} from "../Utils/appConstants"
import SortIcon from "../assets/WebFont/sort.svg";
import { TableSortLabel } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { Box } from "@material-ui/core";
import { getVehicalStatusHistory } from "../service/api";
import moment from "moment";

const useStyles = makeStyles({
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
    backgroundColor: "#f7f7f8",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
});


export default function StatusHistory(props) {
  const classes = useStyles();
  const vin = props.vin;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('transactiondate');
  const [statusHistoryData, setStatusHistoryData] = useState([]);
  const [loaded,setLoaded] = useState(false);
  const handleRequestSort = (
    property
  ) => {
    // console.log(property);
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const descendingComparator = (a, b, orderBy) => {
    // console.log(a[orderBy]);
    if(a[orderBy]===null && b[orderBy]===null)
    return 0;
    else if (a[orderBy]===null)
    return 1;
    else if(b[orderBy]===null)
    return -1;
    else if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }


  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  useEffect(() => {
    // console.log(statusHistoryData);
    if (statusHistoryData.length > 0) {
      const updatedData = stableSort(statusHistoryData, getComparator(order, orderBy));
      // console.log(updatedData);
      setStatusHistoryData(updatedData);
    }
  }, [order, orderBy]);

  useEffect(() => {
    getStatusHistory();
  }, [vin]);

  async function getStatusHistory() {
    let apiResponse = await getVehicalStatusHistory(vin);
    if (apiResponse && apiResponse?.data) {
    // console.log("getVehicalStatusHistory==>", apiResponse);
    const apiResponseVehicleDetails= apiResponse?.data.map(item=>({
      account:item?.account,
      make:item?.make,
      model:item?.model,
      modelyear:item?.modelyear,
      notes:item?.notes,
      transactionid:item?.transactionid,
      userid:item?.userid,
      status:item?.vehicleStatusHistoryId?.status,
      transactiondate:item?.vehicleStatusHistoryId?.transactiondate,
      transactiontype:item?.vehicleStatusHistoryId?.transactiontype,
      vin:item?.vehicleStatusHistoryId?.vin,
    }));
    console.log("getVehicalStatusHistory==>", apiResponseVehicleDetails);
    if (apiResponseVehicleDetails.length > 0) {
      const updatedData = stableSort(apiResponseVehicleDetails, getComparator(order, orderBy));
      // console.log(updatedData);
      setStatusHistoryData(updatedData);
    }
    setLoaded(true);
    }
  }


  return (
    <Box>
      <Box display={"flex"} alignItems={"center"} mb={2}>
        <Box className="resultForVin">
          Results for VIN: {vin}
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHeaderRow}>
              <TableRow className={classes.tableHeadFont}>
                {VehicleStatusHeading.map((item) => {
                  return (
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === item.id}
                        direction={orderBy === item.id ? order : 'asc'}
                        onClick={() => handleRequestSort(item.id)}
                        IconComponent={() => (
                          <img src={SortIcon} alt="sort" className="tableSortIcon" />
                        )}
                      >
                        {item.label}
                      </TableSortLabel>
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
          <TableBody>
          {loaded && statusHistoryData.length===0 ?
               (<TableRow>
                <TableCell colSpan={4} style={{textAlign: 'center' , width:'100%'}}>No Status Found</TableCell>
               </TableRow> )   
             : (statusHistoryData.length>0 && 
              statusHistoryData.map((row, index) => (
                row && <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {row?.transactiontype}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.status}
                  </TableCell>
                  <TableCell>{row?.userid}</TableCell>
                  <TableCell>
                    {row?.transactiondate && row?.transactiondate !== 'NA' &&
                      `${moment(row?.transactiondate).format("MM/DD/YYYY")} ${moment(row?.transactiondate).format("hh:mm a")}`}
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
